const namespace = 'GLOBAL_ASK_AICA_';

export const GLOBAL_ASK_AICA_CONSTANTS = {
    ADD_MESSAGE: `${namespace}ADD_MESSAGE`,
    UPDATE_MESSAGE: `${namespace}UPDATE_MESSAGE`,
    INITIALISE_MESSAGE_THREAD: `${namespace}INITIALISE_MESSAGE_THREAD`,
    SET_IS_LOADING: `${namespace}SET_IS_LOADING`,
    SET_IS_LOADING_CHAT_HISTORY: `${namespace}SET_IS_LOADING_CHAT_HISTORY`,
    SET_ERROR: `${namespace}SET_ERROR`,
    SET_REASONING: `${namespace}SET_REASONING`,
    RESET_REASONING: `${namespace}RESET_REASONING`,

    // Gate-transition constants. NOTE: `decline`/`companyLess` are set as part of
    // SET_GATE_OUTCOME (see reducer.ts::applyGateOutcome) — there is deliberately
    // no standalone SET_DECLINE/SET_COMPANY_LESS action (removed as dead code,
    // human review #15: defined but never dispatched anywhere).
    SET_GATE_OUTCOME: `${namespace}SET_GATE_OUTCOME`,
    SET_CURRENT_COMPANY: `${namespace}SET_CURRENT_COMPANY`,
    SET_ASK_BACK: `${namespace}SET_ASK_BACK`,

    SET_CONVERSATION_ID: `${namespace}SET_CONVERSATION_ID`,
    RESET_GLOBAL_CHAT: `${namespace}RESET_GLOBAL_CHAT`,
    RESET_GATE_STATE: `${namespace}RESET_GATE_STATE`,

    SET_CONVERSATIONS: `${namespace}SET_CONVERSATIONS`,
    SET_LOADING_CONVERSATIONS: `${namespace}SET_LOADING_CONVERSATIONS`,

    SET_SELECTED_SOURCES: `${namespace}SET_SELECTED_SOURCES`,

    SET_IS_CLEARING_CHAT: `${namespace}SET_IS_CLEARING_CHAT`,
    SET_HAS_MORE_DATA: `${namespace}SET_HAS_MORE_DATA`,
};

/** Athena endpoints — relative to athenaBaseUrl (which already ends in "/athena"). */
export const GLOBAL_ASK_AICA_ENDPOINTS = {
    CHAT: '/chat',
    CONVERSATIONS_USER: '/chat/conversations/user',
    CONVERSATION_HISTORY: '/chat/conversation/history',
};

export const DEFAULT_GLOBAL_SOURCES = ['searchTheWeb', 'trustedPublicRecords', 'consentData', 'dataRoom'];

/** Explicit page_size for restoring the user's single portfolio conversation's
 * history (F-9/F-D). Athena validates `page_size` as `Query(5, ge=1, le=50)` —
 * 200 was above the BE's ceiling and made every resume-on-open request 422,
 * rendering a blank panel (RECUR-27369 R-1). 50 is the largest page Athena
 * will accept. There is no "load more" UI wired on the portfolio surface yet
 * (see hasMoreData / MessagesContainer's `fetchChatHistory` no-op there) — a
 * conversation longer than 50 pairs (100 messages) stays truncated until that
 * follow-up ships; hasMoreData at least surfaces that a page was full. */
export const GLOBAL_HISTORY_PAGE_SIZE = 50;

/** Prefix of Athena's raw ask_back(kind:"pick") prompt text ("I found multiple
 * companies matching 'X'. Which one did you mean? 1. … 2. … 3. …"). The docked
 * CompanyPicker is the whole response for that turn — this prompt must never
 * render as a chat bubble. Live turns are fixed at the source (see
 * useGlobalAskAica.runTurn, which never persists it as message content); this
 * prefix is a content-match guard for conversations reloaded from backend
 * history, which carries no per-turn gate_outcome to key off structurally. */
export const ASK_BACK_PROMPT_PREFIX = 'I found multiple companies matching';

/** Figma is the source of truth for this copy — do not reword. */
export const GLOBAL_ASK_AICA_COPY = {
    CHIP_PREFIX: 'Answering for',
    PICKER_TITLE: 'Select correct company here',
    ENTRY_LABEL: 'Ask AICA',
    /** Fallback when Athena resolves a company without a display name (F-15) —
     * mirrors the leads ConversationSidebar's "Unknown user" fallback pattern. */
    UNKNOWN_COMPANY: 'Unknown company',
};
